export default __webpack_public_path__ + "static/media/Planner_128x128.387ca8fb.webp";